 <div [hidden]="consulta">
    <div class="row">
        <div class="col-lg-12" style="padding: 0px;">
            <section class="widget">
               <!-- título -->
                <header>
                    <h3> {{sistemaService.NombrePantallaActual}}: {{accion.accion}}</h3>
                </header>
            </section>
            <section class="widget">
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                        <inputCustom [titulo]="'Ciclo'" [disabled]="true" [(ngModel)]="entidad.ciclo" [errorActivo]="errorActivo" ></inputCustom>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                        <inputCustom [titulo]="'Nombre del periodo de evaluación'" [disabled]="true" [(ngModel)]="entidad.descripcion" [errorActivo]="errorActivo" ></inputCustom>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-4 col-md-6 col-sm-12 col-12">
                        <inputCustom [titulo]="'Tipo de evaluación'" [disabled]="true" [(ngModel)]="accion.entidad.nombre" [errorActivo]="errorActivo" ></inputCustom>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12 col-12">
                        <inputCustom [titulo]="'Nivel'" [disabled]="true" [(ngModel)]="accion.entidad.nivel" [errorActivo]="errorActivo" ></inputCustom>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12 col-12">
                        <inputCustom [titulo]="'Grado'" [disabled]="true" [(ngModel)]="accion.entidad.grado" [errorActivo]="errorActivo" ></inputCustom>
                    </div>
                </div>

                <div>
                    <h5>Asigne las evaluaciones de padres de familia a profesores</h5>
                    <div class="row margen">
                        <div class="col-12">
                            <div class="panelBotonesFiltro mixto">
                                <button matTooltip="Manual" class="btn boton botonXS" [class.disabled]="visualizador" (click)="Modal()">
                                    <span class="fa fa-plus"></span>
                                    <span> {{'Asignación manual'}}</span>
                                </button>
                                <div class="divisorH16 "></div>
                                <button matTooltip="Manual" class="btn boton botonXS" [class.disabled]="visualizador" (click)="ModalInterno()">
                                    <span class="fa fa-random"></span>
                                    <span> {{'Asignación aleatorio'}}</span>
                                </button>
                            </div>
                        </div>
                    </div>


                   <!--  datos -->
                    <div >
                        <dx-data-grid
                            (onOptionChanged)="sistemaService.CambiarPaginacionTabla($event)"
                            id="tabla"
                            [columnAutoWidth]="true"
                            [noDataText]="'Sin Datos'"
                            [dataSource]="Datapadresmaestros"
                            [showColumnHeaders]="true"
                            (onInitialized)="onInitialized($event)"
                            (onRowPrepared)="onRowPrepared($event)"
                            >

                            <dxo-search-panel
                                [visible]="true"
                                [width]="240"
                                placeholder="{{'Buscar' | translate}}">
                            </dxo-search-panel>
                            <dxo-paging [pageSize]="0"></dxo-paging>
                            <dxo-pager
                                [visible]="false"
                                [allowedPageSizes]="sistemaService.tablaPaginacionPaginaSize"
                                [displayMode]="sistemaService.tablaPaginacionModo"
                                [showPageSizeSelector]="sistemaService.tablaPaginacionSelector"
                                [showInfo]="sistemaService.tablaPaginacionInfo"
                                [showNavigationButtons]="sistemaService.tablaPaginacionNavegacion">
                            </dxo-pager>
                            <dxi-column
                                dataField="gradoygrupo"
                                [groupIndex]="1"
                                groupCellTemplate="groupCellTemplateGrado"
                                [autoExpandGroup]="false"
                                width="40px">
                            </dxi-column>
                            <dxi-column
                                dataField="colaborador"
                                [groupIndex]="0"
                                groupCellTemplate="groupCellTemplateColaborador"
                                [autoExpandGroup]="true">
                            </dxi-column>
                            <dxi-column
                                dataField="matricula"
                                caption="Matrícula"
                                width="100px"
                                alignment="left"
                                >
                            </dxi-column>
                            <dxi-column
                                dataField="alumno"
                                caption="Alumno">
                            </dxi-column>

                            <div *dxTemplate="let cellInfocolaborador of 'groupCellTemplateColaborador'">
                                <div class="accionEncabezado">
                                    <div class="accionEncabezado__titulo">
                                        {{cellInfocolaborador.value}}
                                    </div>
                                    <div class="accionEncabezado__acciones">
                                        <span>{{cellInfocolaborador.data.total}} evaluaciones asignadas</span>
                                        <a matTooltip="Editar" class="tablaBoton separado edit" (click)="Formulario(cellInfocolaborador)" [class.disabled]="visualizador" *ngIf="sistemaService.permisos.editar">
                                            <i class="fa fa-pencil fa-lg" aria-hidden="true"></i>
                                        </a>
                                        <a matTooltip="Eliminar" class="tablaBoton separado delete" (click)="Eliminar(cellInfocolaborador)" [class.disabled]="visualizador" *ngIf="sistemaService.permisos.eliminar">
                                            <i class="fa fa-trash fa-lg" aria-hidden="true"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div *dxTemplate="let cellInfoGrado of 'groupCellTemplateGrado'">
                                <div class="accionEncabezado">
                                    <div class="accionEncabezado__titulo">
                                        <span class="accionEncabezado__titulo--subgrupo">{{cellInfoGrado.value}}</span>
                                    </div>
                                    <div class="accionEncabezado__acciones" >
                                        <a matTooltip="Eliminar" class="tablaBoton separado delete" (click)="EliminarGrado(cellInfoGrado)" [class.disabled]="visualizador" *ngIf="sistemaService.permisos.eliminar">
                                            <i class="fa fa-trash fa-lg" aria-hidden="true"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </dx-data-grid>
                    </div>
                </div>
                <div class="divisor20"></div>
                <div class="row margen" >
                    <div class="col-12">
                        <div class="panelBotonesFiltro">
                            <button matTooltip="Cancelar" class="boton botonSM filledBlanco"
                                    (click)="Salir()">
                                <span> {{'Cancelar'}}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</div>


<ng-container *ngIf="abierto">
    <div class="backdrop"></div>
    <div class="modalPanelAdmin animated {{animacion}}">

        <div class="contenido">
           <!--  Título -->
            <div class="encabezadoModal">
                <div class="modalTituloSimple">
                    {{('Generar asignación de evaluaciones aleatoria')}}
                </div>
            </div>
            <div class="modalContenido">
               <!--  datos -->
                <div>
                    <h5>Especifica la cantidad de alumnos por grupo, subgrupo o taller que deberán asignarse a cada profesor de manera aleatoria. Si el grupo, subgrupo o taller tiene menos alumnos que la cantidad especificada, se asginará el grupo, subgrupo o taller completo.</h5>
                    <div class="divisor8"></div>
                    <div>
                       <!--  Datos generales -->
                        <div class="row">
                            <div class="col-lg-4 col-md-4 col-sm-6 col-12">
                                <inputCustom
                                    [titulo]="'Cantidad de alumnos por grupo'" [(ngModel)]="cantidadalumnoaleatorio" [errorActivo]="errorActivo" [mask]="sistemaService.numeroEnteroMask"
                                    ></inputCustom>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

           <!--  footer -->
            <div class="modalFooter">
                <div class="contenidoFooter botonesIzq">
                   <!--  editar -->
                    <div class="botonDerecha">
                        <button class="boton botonSM filledBlanco" (click)="CerrarModalInterno()">
                            {{'Cancelar' | translate}}
                        </button>
                        <div class="divisorH16"></div>
                        <button class="boton botonSM filled" (click)="GuardarCantidad()">
                            {{'Guardar' | translate}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<colaboradorevaluacionmodal
    #colaborador
    (respuesta)="GuardarColaborador($event)"
    ></colaboradorevaluacionmodal>

<asignacionalumnonmodal
    #asignacionalumno
    [cicloid]="entidad.cicloid"
    [nivelid]="nivelid"
    (respuesta)="GuardarAlumno($event)"
    ></asignacionalumnonmodal>
